:host {
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  --cms-link-text-color: var(--cms-text-color, var(--cms-theme-text-color));
  --cms-link-text-decoration: var(--cms-link-decoration, underline);
  --cms-link-text-decoration-hover: var(--cms-link-decoration-hover, none);
  gap: var(--cms-spacing-050);
}

:host(:not([type="text"])) {
  --cms-link-font-size: var(--cms-font-size-100);
  --cms-link-line-height: var(--cms-line-height-125);
  --cms-link-font-family: var(--cms-brandfont2);
  --cms-link-font-weight: var(--cms-base-link-font-weight);
  --cms-link-spacing-top: var(--cms-spacing-050);
  --cms-link-spacing-bottom: var(--cms-spacing-050);
}

:host([type="text"]) {
  --cms-link-font-size: var(--cms-font-size, --cms-font-size-100);
  --cms-link-line-height: var(--cms-line-height, --cms-line-height-100);
  --cms-link-font-family: var(--cms-font-family, --cms-brandfont2);
  --cms-link-font-weight: var(--cms-font-weight, --cms-base-font-weight);
  --cms-link-spacing-top: var(--cms-spacing-top, --cms-spacing-050);
  --cms-link-spacing-bottom: var(--cms-spacing-bottom, --cms-spacing-050);
}

:host(.sm) {
  --cms-link-spacing-top: var(--cms-spacing-025);
  --cms-link-spacing-bottom: var(--cms-spacing-025);
  --cms-link-line-height: var(--cms-line-height-125);
}

:host(.md) {
  --cms-link-spacing-top: var(--cms-spacing-050);
  --cms-link-spacing-bottom: var(--cms-spacing-050);
}

:host(.lg) {
  --cms-link-spacing-top: var(--cms-spacing-100);
  --cms-link-spacing-bottom: var(--cms-spacing-100);
  --cms-link-font-size: var(--cms-font-size-125);
  --cms-link-line-height: var(--cms-line-height-125);
}

:host(.spacing-none) {
  --cms-link-spacing-top: 0;
  --cms-link-spacing-bottom: 0;
}

:host(.spacing-top) {
  --cms-link-spacing-bottom: 0;
}

:host(.spacing-bottom) {
  --cms-link-spacing-top: 0;
}

.link {
  text-decoration-line: var(--cms-link-text-decoration);
  background-color: transparent;
  color: var(--cms-link-text-color);
}

:host(.standalone-inverted) .link {
  --cms-link-text-decoration: var(--cms-link-decoration, none);

  &:hover {
    --cms-link-text-decoration-hover: var(--cms-link-decoration-hover, underline);
  }
}

:host(.standalone) .link,
:host(.standalone-inverted) .link {

  &:hover {
    text-decoration-line: var(--cms-link-text-decoration-hover);
  }

  text-decoration-thickness: 0.125rem;
  text-underline-offset: 0.1875rem;
  text-decoration-color: var(--cms-link-text-color);
  padding: var(--cms-link-spacing-top) 0 var(--cms-link-spacing-bottom) 0;
  display: block;
  font-size: var(--cms-link-font-size);
  line-height: var(--cms-link-line-height);
  font-family: var(--cms-link-font-family);
  font-weight: var(--cms-heading-base-font-weight);

}

.icon {
  --cms-theme-svg-color: var(--cms-link-text-color);
}

:host(.nowrap) {
  max-width: 100%;

  .link {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}